<script setup>
import Prospectus from "@/components/pages/prospectus";
import merchApiDrive from "@/services/http/api-drive/magasin/merch";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useMagasinStore } from "@/store/magasin";

const { trackPage } = useTrackingPage();

const height = ref(950);

definePageMeta({
  layout: "none"
});

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.prospectus);
  height.value = window.innerHeight;
});

const { id: magasinId } = useMagasinStore();
const { path } = useRoute();

let prospectusList = [];

const url = path.replace("/prospectus/borne", "");

const { data } = await useAsyncData((app) =>
  app.$apiDrive.use(merchApiDrive).prospectus(magasinId)
);

if (data.value) {
  prospectusList = data.value.data;
}

const prospectus = prospectusList.find((p) => {
  return (
    p.attributes.url.replace(/\/\//g, "/").includes(url) ||
    p.attributes.url.includes(url)
  );
});

useHead(() => {
  return {
    title: prospectus
      ? `Prospectus : ${prospectus.attributes.title}`
      : "Prospectus",
    link: [{ rel: "canonical", href: path }],
    __dangerouslyDisableSanitizers: ["script"],
    script: [
      {
        src: "",
        hid: "onetrust"
      }
    ]
  };
});
</script>

<template>
  <Prospectus
    :url="url"
    :page="$route.query.page ? parseInt($route.query.page) : 1"
    :prospectus="prospectus"
    :iframe-height="height"
    borne
  />
</template>

<style scoped lang="scss">
</style>
